module.exports = __webpack_public_path__ + "img/cctv-emergency.01e213bb.png";